import { BaseComponent } from '@pixelart/component-handler';
import { ParallaxItemOptions } from './parallaxItemOptions.interface';

export class ParallaxItem extends BaseComponent {

    private config: ParallaxItemOptions = {
        INITIALIZED_CLASS: 'parallax-element--initialized',
        key: 0,
        parentDistance: 100,
    };
    private distance: number;
    private dampingFactor: number;
    private parentDistance: number;
    private position: number;

    constructor(element: Element, config?: ParallaxItemOptions) {
        super(element);
        this.config = (Object as any).assign(this.config, config);

        if (!this.parentDistance) {
            this.parentDistance = this.config.parentDistance;
        }
    }

    public init() {
        this.distance = parseInt(this.$element.data('distance'), 10);
        this.distance = this.distance ? this.distance : 0;
        this.dampingFactor = this.distance / this.parentDistance;
        this.$element.addClass(this.config.INITIALIZED_CLASS);
    }

    public setPosition(pixels: number) {
        this.position = -pixels * this.dampingFactor;
    }

    public updatePosition() {
        this.$element.css('transform', 'translateY(' + (this.position) + 'px) translateZ(0)');
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/parallax-content/parallax-item.class.ts